import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { MapPin, Phone, Mail, Clock, Building2, Map, Instagram, Music2, ArrowRight } from "lucide-react";

export default function Contact() {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/content/contact").then((r) => setC(r.data || {})).catch(() => {}); }, []);

  const items = [
    c.address && { icon: MapPin, label: "Adresse", value: c.address },
    c.phone && { icon: Phone, label: "Telefon", value: c.phone, href: `tel:${c.phone.replace(/\s/g, "")}` },
    c.email && { icon: Mail, label: "E-post", value: c.email, href: `mailto:${c.email}` },
    c.hours && { icon: Clock, label: "Åpningstider", value: c.hours },
    c.org_number && { icon: Building2, label: "Organisasjonsnummer", value: c.org_number },
  ].filter(Boolean);

  const socials = [
    c.maps_link && { icon: Map, label: "Google Maps", href: c.maps_link },
    c.instagram && { icon: Instagram, label: "Instagram", href: c.instagram },
    c.tiktok && { icon: Music2, label: "TikTok", href: c.tiktok },
  ].filter(Boolean);

  return (
    <section id="kontakt" className="py-16 sm:py-24 bg-white" data-testid="contact-section">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <div className="max-w-xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-electric">Kontakt</span>
          <h2 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-navy">Kontakt MobilHub</h2>
          <p className="mt-3 text-ink/70">Ta kontakt, så hjelper vi deg med enheten din.</p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-3">
            {items.length === 0 ? (
              <p className="text-ink/50 text-sm">Kontaktinformasjon publiseres snart.</p>
            ) : items.map((it) => (
              <div key={it.label} className="flex items-start gap-3 rounded-xl border border-hairline bg-offwhite p-4" data-testid={`contact-${it.label}`}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-electric/10 text-electric"><it.icon className="h-5 w-5" /></span>
                <div>
                  <p className="text-xs uppercase tracking-wide text-ink/50">{it.label}</p>
                  {it.href ? (
                    <a href={it.href} className="font-medium text-navy hover:text-electric">{it.value}</a>
                  ) : (
                    <p className="font-medium text-navy whitespace-pre-line">{it.value}</p>
                  )}
                </div>
              </div>
            ))}

            {socials.length > 0 && (
              <div className="flex flex-wrap gap-2 pt-1">
                {socials.map((s) => (
                  <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-hairline bg-white px-4 py-2 text-sm font-medium text-navy hover:border-electric" data-testid={`social-${s.label}`}>
                    <s.icon className="h-4 w-4 text-electric" /> {s.label}
                  </a>
                ))}
              </div>
            )}
          </div>

          <div className="rounded-2xl bg-navy p-8 text-white flex flex-col justify-center">
            <h3 className="font-heading text-2xl font-bold">Klar til å reparere?</h3>
            <p className="mt-2 text-slate-300">Bestill time på under ett minutt, eller be om et pristilbud.</p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <button onClick={() => document.querySelector("#bestill")?.scrollIntoView({ behavior: "smooth" })} className="inline-flex items-center justify-center gap-2 rounded-full bg-warm px-6 py-3 text-sm font-semibold text-navy hover:bg-warm-dark" data-testid="contact-book-button">
                Bestill time <ArrowRight className="h-4 w-4" />
              </button>
              <button onClick={() => document.querySelector("#priser")?.scrollIntoView({ behavior: "smooth" })} className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white hover:bg-white/10" data-testid="contact-price-button">
                Beregn pris
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
